"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var memoize = require("fast-memoize");
var ColumnFilter_1 = require("components/ColumnFilter");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var sok_ui_1 = require("@caddigital/sok-ui");
var DistributionListActions = require("@caddigital/sok-reducers/lib/actions/distribution/list");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/distribution/wizard");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var moment = require("moment");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var components_1 = require("components");
var text_1 = require("utils/text");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'name',
    'description',
    'author',
    'createdAt',
    'modifiedAt'
];
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        list: state.distribution.list,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage,
        user: state.auth.current.user
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleEdit: function (item) { return function () {
        return dispatch(WizardActions.openEditMenu(item));
    }; },
    fetchDistributionList: function (project) {
        return dispatch(DistributionListActions.fetchDistributionListRequest(project));
    },
    onPaginationChange: function (offset, limit) { return (dispatch(DistributionListActions.setLimit(limit)),
        dispatch(DistributionListActions.setOffset(offset))); },
    setOffset: function (offset) {
        return dispatch(DistributionListActions.setOffset(offset));
    },
    sortBy: function (orderBy, order) {
        return dispatch(DistributionListActions.setOrderByOptions(orderBy, order));
    },
    setColumnFilter: function (filter, value) {
        return dispatch(DistributionListActions.setFilterOptions(filter, value));
    },
    selectItems: function (items) {
        return dispatch(DistributionListActions.selectItems(items));
    },
    unselectItems: function (items) {
        return dispatch(DistributionListActions.unselectItems(items));
    },
    toggleSelect: function (item, selected) {
        return selected
            ? dispatch(DistributionListActions.selectItems([item.id]))
            : dispatch(DistributionListActions.unselectItems([item.id]));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
function getFilteredData(list, searchString, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (searchString.length > 0) {
            return list.filter(function (item) {
                return item.name
                    .toString()
                    .toLowerCase()
                    .includes(searchString.toLowerCase()) ||
                    (item.author &&
                        item.author
                            .toString()
                            .toLowerCase()
                            .includes(searchString.toLowerCase()));
            });
        }
        return list;
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            switch (key) {
                case 'modifiedAt':
                case 'createdAt': {
                    var searchValue_1 = filters[key];
                    var x = item[key];
                    var value_1 = x !== null ? moment(x).format('L') : '-';
                    if (searchValue_1 !== value_1) {
                        return result;
                    }
                    break;
                }
                case 'author': {
                    var searchValue_2 = filters[key];
                    var value_2 = userLens_1.getName.get(item[key]);
                    if (value_2.toLowerCase().indexOf(searchValue_2.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                default:
                    var searchValue = filters[key];
                    var value = item[key];
                    if (value
                        .toString()
                        .toLowerCase()
                        .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
            }
        }
        if (item.name.toLowerCase().toString().includes(searchString.toLowerCase()) ||
            (item.author &&
                userLens_1.getName
                    .get(item.author)
                    .toLowerCase()
                    .toString()
                    .includes(searchString.toLowerCase()))) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.list.searchString !== nextProps.list.searchString ||
            this.props.list.orderByOptions !== nextProps.list.orderByOptions ||
            this.props.list.filterOptions !== nextProps.list.filterOptions ||
            this.props.list.offset !== nextProps.list.offset ||
            this.props.list.limit !== nextProps.list.limit ||
            (this.props.list.list.length === 0 && nextProps.list.list.length) ||
            this.props.list.list.length !== nextProps.list.list.length ||
            (this.props.list.status !== 'FETCHED' &&
                nextProps.list.status === 'FETCHED')) {
            var orderBy_1 = nextProps.list.orderByOptions.orderBy;
            var order_1 = nextProps.list.orderByOptions.order === 'asc' ? 1 : -1;
            var list = nextProps.list;
            var data = getFilteredData(list.list, nextProps.list.searchString, nextProps.list.filterOptions).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'name':
                    case 'description':
                        return (a[orderBy_1] || '').localeCompare(b[orderBy_1] || '') * order_1;
                    case 'author':
                        return (userLens_1.getName
                            .get(a.author || undefined)
                            .localeCompare(userLens_1.getName.get(b.author || undefined)) * order_1);
                    case 'modifiedAt':
                    case 'createdAt': {
                        var a2 = moment(a[orderBy_1] || 0);
                        var b2 = moment(b[orderBy_1] || 0);
                        return a2.diff(b2) * order_1;
                    }
                    case 'id':
                        return (a[orderBy_1] - b[orderBy_1]) * order_1;
                    default:
                        return 0;
                }
            });
            var items = data.slice(Math.max(0, Math.min(data.length, list.offset)), Math.min(list.offset + list.limit, data.length));
            nextProps.setTotal(data.length);
            nextProps.setItems(items);
        }
        if (this.props.list.searchString !== nextProps.list.searchString ||
            this.props.list.filterOptions !== nextProps.list.filterOptions) {
            nextProps.setOffset(0);
        }
        if (nextProps.items !== this.props.items ||
            this.props.contentWidth === 0) {
            var contentWidth_1 = 0;
            var columns_1 = nextProps.list.list.reduce(function (p, item) {
                Object.keys(item).forEach(function (c) {
                    if (c === 'id' || c === 'project' || c === 'recipients') {
                        return p;
                    }
                    var dataKey = '__distribution__' + c.replace(/-/g, '');
                    var text = (function (v, c) {
                        if (c === 'createdAt' || c === 'modifiedAt') {
                            return v && v.toString().length > 0
                                ? moment(v, 'x').format('L LT')
                                : '--';
                        }
                        else if (c === 'author') {
                            return userLens_1.getName.get(v);
                        }
                        return (v || '').toString();
                    })(item[c], c);
                    var length = (0, text_1.calculateStringLength)(text);
                    var prevValue = p[dataKey];
                    if (prevValue && prevValue.length < length) {
                        prevValue.text = text;
                        prevValue.length = length;
                    }
                    else if (!prevValue) {
                        p[dataKey] = {
                            text: text,
                            length: length
                        };
                    }
                });
                return p;
            }, {});
            headers.forEach(function (x) {
                var dataKey = '__distribution__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("userfront/distribution/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue.length < length) {
                    prevValue.text = text;
                    prevValue.length = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = {
                        text: text,
                        length: length
                    };
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('DistributionListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'DistributionListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 3 * 42;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            nextProps.setContentWidth(contentWidth_1);
        }
    }
}), recompose_1.pure);
function getHeaderColumn(props, name, identifier) {
    var order = props.list.orderByOptions.orderBy === identifier &&
        props.list.orderByOptions.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__distribution__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column distribution-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () { return props.sortBy(identifier, order); } }, (0, translation_1.getLocalization)("userfront/distribution/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.list.orderByOptions.orderBy === identifier
                ? props.list.orderByOptions.order.toLowerCase()
                : null, disabled: !enabled, onChange: function () { return props.sortBy(identifier, order); } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: props.list.filterOptions && props.list.filterOptions[identifier]
                ? 'active'
                : '' + ' filter', columnIdentifier: identifier, textInputValue: props.list.filterOptions && props.list.filterOptions[identifier]
                ? props.list.filterOptions[identifier] || ''
                : '', inputType: identifier === 'createdAt' || identifier === 'modifiedAt'
                ? 'day'
                : 'text', setColumnFilterString: function (field, value) {
                return props.setColumnFilter(field, value);
            }, clearColumnFilter: function (field) { return props.setColumnFilter(field, undefined); } })));
}
var Header = function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column first narrow" }),
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', className: props.allSelected === true ? 'selected' : '', circle: true, onClick: function (e) {
                    e.stopPropagation();
                    if (props.allSelected) {
                        props.unselectItems(props.items.map(function (x) { return x.id; }));
                    }
                    else {
                        props.selectItems(props.items.map(function (x) { return x.id; }));
                    }
                } })),
        React.createElement("div", { className: "row__column first narrow" }),
        getHeaderColumn(props, 'name', 'name'),
        getHeaderColumn(props, 'description', 'description'),
        getHeaderColumn(props, 'author', 'author'),
        getHeaderColumn(props, 'createdAt', 'createdAt'),
        getHeaderColumn(props, 'modifiedAt', 'modifiedAt')));
};
function getColumn(column, value, onClick) {
    return (React.createElement("div", { className: classNames("row__column __distribution__".concat(column), column === 'name' && 'expand'), "data-key": "__distribution__".concat(column), "data-length": value.length, onClick: onClick },
        React.createElement("span", null, value)));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-distribution-lists', className: 'no-distribution-lists' }),
    React.createElement("img", { src: '/assets/images/delivery_200x200.png' }),
    React.createElement("b", null, (0, translation_1.getLocalization)('userfront/distributionlist/noDistributionLists/noDistributionsNotice')),
    React.createElement("span", null, (0, translation_1.getLocalization)('userfront/distributionlist/noDistributionLists/noDistributionsText')))); };
var createRowData = memoize(function (style, isMobile, items, selections, toggleEdit, toggleSelect, user, project) { return ({
    style: style,
    isMobile: isMobile,
    items: items,
    selections: selections,
    toggleEdit: toggleEdit,
    toggleSelect: toggleSelect,
    user: user,
    project: project
}); });
function canEditDistributionList(item, maybeUser, project) {
    if (maybeUser.isNone()) {
        return false;
    }
    var user = maybeUser.value;
    var isProjectAdmin = project.perm & acl.PROJECT_ADMIN_GRANT;
    if (isProjectAdmin) {
        return true;
    }
    switch (user.level) {
        // these should definitely be typed and/or be matched against constant values.
        case 'SuperAdminUserGroup':
        case 'CustomerAdminUserGroup':
            return true;
    }
    return !!item.author && user.uuid === item.author.uuid;
}
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    // this is stupid and we should type the props explicitly.
    // unfortunately the <List /> component is designed in such
    // a way that it expectes the children to be un-instantiated
    // react components, which seems like a total disaster to me.
    //
    // we lose type safety and the ability to reason about the DOM
    // structure.
    //
    //   -jbjork, 2023-03-30
    var isMobile = data.isMobile, items = data.items, selections = data.selections, toggleEdit = data.toggleEdit, toggleSelect = data.toggleSelect, user = data.user, project = data.project;
    var row = items[index];
    var selected = !!selections[row.id];
    var createdAt = row.createdAt ? moment(row.createdAt).format('L LT') : '-';
    var modifiedAt = row.modifiedAt
        ? moment(row.modifiedAt).format('L LT')
        : '-';
    var onClickToggleEdit = toggleEdit(row);
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-clipboard-list' })),
        React.createElement("div", { className: "row__column narrow" },
            React.createElement(components_1.TableRowIcon, { icon: 'fa-check', className: selected ? 'selected' : '', circle: true, onClick: function (e) {
                    e.stopPropagation();
                    toggleSelect(row, !selected);
                } })),
        React.createElement("div", { className: "row__column narrow" }, canEditDistributionList(row, user, project) ? (React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-pencil', className: 'black', onClick: onClickToggleEdit })) : undefined),
        getColumn('name', row.name, onClickToggleEdit),
        getColumn('description', row.description),
        getColumn('author', userLens_1.getName.get(row.author || undefined)),
        getColumn('createdAt', createdAt),
        getColumn('modifiedAt', modifiedAt)));
});
exports.ListContainer = enhance(function (props) {
    var selected = props.list.selected.reduce(function (p, x) {
        p[x] = true;
        return p;
    }, {});
    var allSelected = props.items.length > 0;
    for (var i = 0; i < props.items.length; i++) {
        if (!selected[props.items[i].id]) {
            allSelected = false;
            break;
        }
    }
    // memoize item props into props.data object
    var itemData = createRowData({}, props.isMobile, props.items, selected, props.toggleEdit, props.toggleSelect, props.user, props.currentProject);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'distribution-view-list-container' },
            React.createElement("div", { className: 'sok-list-content distribution-view-list ' +
                    props.list.status.toLowerCase() },
                props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                            return props.fetchDistributionList(props.currentProject);
                        } }))),
                props.list.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.list.status === 'FETCHED' && (React.createElement(React.Fragment, null, props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props, { allSelected: allSelected })), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow));
                })))))),
        React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.list.limit, total: props.total, offset: props.list.offset, updatePageState: props.onPaginationChange })));
});
